// TODO: Pull from environment variables
export const Endpoints = {
    authEndPoint: 'http://localhost:4000/auth',
    subscription: 'http://localhost:4000/create-checkout-session',
    customerPortal: 'http://localhost:4000/create-portal-session',
    price: 'http://localhost:4000/price',
};